import {
  MOCK_INSIGHTS_AI_MESSAGE,
  MOCK_INSIGHTS_AI_METRICS
} from '@percent/partner-dashboard/fixtures/api/insightsAi/mockInsightsAiAnswer'

const frame = (type: string, payload: object): string =>
  `event: ${type}\ndata: ${JSON.stringify({ type, ...payload })}\n\n`

// Canned backend SSE turn (status -> metric parts -> message -> done). The question
// is echoed so thread continuity is visible across turns on localhost.
const turnStream = (question: string): ReadableStream<Uint8Array> => {
  const encoder = new TextEncoder()
  const frames = [
    frame('status', { phase: 'thinking' }),
    ...MOCK_INSIGHTS_AI_METRICS.map(metric => frame('data', { name: 'metric', data: metric })),
    frame('message', { text: `[re: "${question}"] ${MOCK_INSIGHTS_AI_MESSAGE}` }),
    frame('done', { threadId: 'thread_mock_insights_ai' })
  ]

  return new ReadableStream<Uint8Array>({
    start(controller) {
      frames.forEach(chunk => controller.enqueue(encoder.encode(chunk)))
      controller.close()
    }
  })
}

const questionOf = (init?: RequestInit): string => {
  try {
    return (JSON.parse(String(init?.body ?? '{}')) as { message?: string }).message ?? ''
  } catch {
    return ''
  }
}

// Injected into useAiChat on local dev / tests: answers the thread-open + message
// endpoints with a canned SSE turn; other URLs fall through to real fetch.
export const mockInsightsChatFetch: typeof globalThis.fetch = async (input, init) => {
  const url = String(input instanceof Request ? input.url : input)

  if (url.endsWith('/threads')) {
    return new Response(JSON.stringify({ object: 'ai_chat_thread', data: { id: 'thread_mock_insights_ai' } }), {
      status: 201,
      headers: { 'Content-Type': 'application/json' }
    })
  }

  if (url.includes('/threads/') && url.endsWith('/messages')) {
    return new Response(turnStream(questionOf(init)), {
      status: 200,
      headers: { 'Content-Type': 'text/event-stream' }
    })
  }

  return fetch(input, init)
}
